import { base_colorAlert } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.SignInForm {
    .forget-password-link {
      align-self: center;
    }

    .reset-email-button {
      padding: ${spacing(2)} 0;
      justify-content: flex-start;
      text-decoration: underline;
    }

    .reset-email-button-text,
    .signup-link {
      ${font_md}
    }

    .errorText {
      align-self: center;
      color: ${base_colorAlert};
    }
  }
`
